import React, { useEffect, useState } from 'react';

import useTranslate from '../../../common/hooks/useTranslate';
import { useDispatch } from 'react-redux';

import { getUserSettings, saveUserSettings } from '../../services/userService';

import { POPUP } from '../../../redux/types';

import Icon from '../icon/icon';

import './infoTooltip.scss';

const InfoTooltip: React.FC = () => {
  const [tooltipHidden, setTooltipHidden] = useState<boolean>(true);

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const closeInfoTooltip = () => {
    setTooltipHidden(true);
    sessionStorage.setItem('docuSlicerTooltipHidden', '1');
  };

  const doNotShowAgain = () => {
    setTooltipHidden(true);
    const slicerTooltipSetting = { name: 'docuSlicerTooltipHidden', value: '1' };
    saveUserSettings(slicerTooltipSetting).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  };

  useEffect(() => {
    const stored = sessionStorage.getItem('docuSlicerTooltipHidden');
    if (stored === null) {
      getUserSettings().then((settings) => {
        const settingHideTooltip = settings.find((setting) => {
          return setting.name === 'docuSlicerTooltipHidden';
        });
        if (settingHideTooltip === undefined) {
          setTooltipHidden(false);
        } else if (settingHideTooltip.value === '1') {
          setTooltipHidden(true);
        } else {
          setTooltipHidden(false);
        }
      }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
    } else {
      setTooltipHidden(true);
    }
  }, []);

  return (
    <div>
      {!tooltipHidden && (
        <div className='filters-slicer-tooltip'>
          <div className='bottom-arrow' />
          <div className='tooltip-content'>
            <p>{t('FILTERS.TOOLTIP_TEXT')}</p>
            <button className='tooltip-button pointer' onClick={doNotShowAgain}>
              {t('FILTERS.TOOLTIP_BUTTON')}
            </button>
          </div>
          <div className='tooltip-right'>
            <Icon name='fas fa-times-circle' className='close-circle-btn pointer' onClick={closeInfoTooltip} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
